import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../../shared/loader";
import {
  uploadShots,
  clearWarnings,
  clearRedirect
} from "./ducks/actions";
import { Upload } from "./upload";
import { useEffect } from "react";

const UploadContainer = (props) => {
  const filmId = props.match.params.filmId;
  const sceneId = props.match.params.sceneId;
  const {
    loading,
    errors,
    warnings,
    shotsOnboardingSteps,
    uploadShots,
    isUploading,
    clearWarnings,
    clearRedirect,
    redirect,
    missingHeaders,
    unexpectedHeaders,
    shotRowIssues
  } = props;

  const onUploadShots = (formData) => {
    uploadShots(filmId, formData, sceneId)
  }

  useEffect(() => {
    clearWarnings();
  },
    []);

  if (redirect) {
    if (redirect.to === "list") {
      clearRedirect();
      const url = `/films/${filmId}/scenes/${sceneId}/shots/overview`;
      return <Redirect to={url} />;
    }
  }

  function renderUpload() {

    return (
      <ScrollIntoView
        className="blade-content wider"
        path="/films/:filmId/shots/upload"
        loading={loading}>
        <h2 className="menu-label">Upload</h2>
        <Upload
          filmId={filmId}
          sceneId={sceneId}
          errors={errors}
          warnings={warnings}
          shotsOnboardingSteps={shotsOnboardingSteps}
          uploadShots={onUploadShots}
          isUploading={isUploading}
          missingHeaders={missingHeaders}
          unexpectedHeaders={unexpectedHeaders}
          shotRowIssues={shotRowIssues} />
        <a href="/downloads/Shots.csv" >Example File</a>
      </ScrollIntoView>
    );
  }

  return (
    <>
      {(loading || isUploading) && <Loader />}
      {!loading && renderUpload()}
    </>
  );
};

function mapStateToProps(state) {
  const { errors, loading, saving, pristine, shotsOnboardingSteps, isUploading, redirect, unexpectedHeaders, missingHeaders, shotRowIssues } =
    state.shotsUploadState;
  return {
    errors,
    loading,
    saving,
    pristine,
    shotsOnboardingSteps,
    isUploading,
    redirect,
    missingHeaders,
    unexpectedHeaders,
    shotRowIssues
  };
}

export default connect(mapStateToProps, {
  uploadShots,
  clearWarnings,
  clearRedirect
})(UploadContainer);
